export default [
  'default',
  'engineHours',
  'pumpedMaterial',
];
